var _defs, _rect, _rect2, _text, _rect3, _text2, _rect4, _text3, _rect5, _text4, _rect6, _text5, _rect7, _text6, _rect8, _text7, _rect9, _text8, _rect10, _text9, _rect11, _text10, _rect12, _br, _text11, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMap6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "241px",
    height: "401px",
    viewBox: "-0.5 -0.5 241 401",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2022-11-18T01:38:34.176Z\" agent=\"5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/107.0.0.0 Safari/537.36\" etag=\"SDrzyN89EN0mLixPGhWB\" version=\"20.5.3\" type=\"device\"><diagram id=\"9p4TfJscrcLIHBW24Trj\" name=\"\\u30DA\\u30FC\\u30B81\">5ZrLcpswFIafRsvOGF1ALMEhySYrL7rsEJANDSAXy7c+fYURxlhqxpmWgMnGc/QfGYnv6HIEADTPD09luE5eeMwyAGfxAaAHAKFDofythGMtYGTXwqpM41qyWmGR/mZKnCl1m8Zs06koOM9Euu6KES8KFomOFpYl33erLXnWbXUdrpgmLKIw09XvaSySWqXQafVnlq6SpmXLdmtPHjaV1Z1skjDm+wsJBQDNS85FbeWHOcsqdg2X+n+Pf/GeO1ayQtzyByLeXn7+ePjFQnuXr3cknKHnbxauL7MLs626Y9VbcWwQlHxbxKy6ygwgf5+kgi3WYVR59zLmUktEnsmSJU29V6qjO1YKdriQVC+fGM+ZKI+yivJCqoipIWPZqrxvAwCx0pIL+HimxFAFfXW+dstFGgrNRzARDZNtgcAGLgGuCwICvAB4eHB0ZwLvoLOgAZ3VHzpbRwfvAB0cATpHR4fuAB0aATqqo8N3gA6PAJ2rbwmBC1wP0KAiKMH5ZHBw15sEdm8E5/TFrWmsww0BmQB59GQg4M2VUQ3Bk+HPVR3/sVVGx5bobKlx/+0LrTVZtNbQaKEBrVwdCfBPW43sjOcofpQ21HFLfWxEEbqNKO2NqCGlDhzgYuA7d0kU3jj9+yOqZ9/NZCcNNk+b9c064Jpc14wlGtEFuRElf2NznvFSKgUvZE1/mWbZlRRm6aqQxUgCZ1L3K9CpPEB6ypGncVw1Y4xcN7ZLXgh1BEY9naVcclMsUW+x1I8D1Xrj+4B6ANpZFYXXUlqrygKBnDUUUP/LBOycO7+znJnOvqS3gOmHkH9boa6YXUYIQLSkEYsiLZzS80pJlYj0lHbr08IyUIZ9UUaG5HF6lA1j+XMpG/LIyVFGztCU0VegPPhY/t9PbsdIGQ4+lg2p5+QoW4NTNiSFk6MMB18xppjJIXJF2fQA9VMpGx6fTo4ywgNTbtqfNGUMh6Y8xXxZozz0ioHhFCk7V5QN72fM77U+TFkW268oTr6LT1FQ8Ac=</diagram></mxfile>",
    style: {
      backgroundColor: "rgb(255, 255, 255)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 240,
    height: 400,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 0,
    width: 120,
    height: 100,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 50,
      marginLeft: 121
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "61\u6559\u5BA4")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 54,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "61\u6559\u5BA4")))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 100,
    width: 120,
    height: 100,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 150,
      marginLeft: 121
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "62\u6559\u5BA4")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 154,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "62\u6559\u5BA4")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 200,
    width: 120,
    height: 100,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 250,
      marginLeft: 121
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "63\u6559\u5BA4")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 254,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "63\u6559\u5BA4")))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 300,
    width: 120,
    height: 100,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 350,
      marginLeft: 121
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "64\u6559\u5BA4")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 354,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "64\u6559\u5BA4")))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 330,
    width: 120,
    height: 70,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 365,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\u968E\u6BB5")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 369,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u968E\u6BB5")))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 290,
    width: 80,
    height: 40,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 310,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\u30A8\u30EC\u30D9\u30FC\u30BF\u30FC")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 314,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u30A8\u30EC\u30D9\u30FC\u30BF\u30FC")))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 250,
    width: 80,
    height: 40,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 270,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\u30A8\u30EC\u30D9\u30FC\u30BF\u30FC")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 274,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u30A8\u30EC\u30D9\u30FC\u30BF\u30FC")))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 170,
    width: 80,
    height: 80,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 210,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\u5973\u6027\u30C8\u30A4\u30EC")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 214,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u5973\u6027\u30C8\u30A4\u30EC")))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 90,
    width: 80,
    height: 80,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 130,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\u7537\u6027\u30C8\u30A4\u30EC")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 134,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u7537\u6027\u30C8\u30A4\u30EC")))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 35,
    width: 80,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 50,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 3,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\u30D5\u30EA\u30FC\u30B9\u30DA\u30FC\u30B9")))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 51,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "3px",
    textAnchor: "middle"
  }, "\u30D5\u30EA\u30FC\u30B9\u30DA\u30FC\u30B9")))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 170,
    width: 40,
    height: 50,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 195,
      marginLeft: 81
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 3,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\u5ECA", _br || (_br = /*#__PURE__*/React.createElement("br", null)), "\u4E0B")))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 196,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "3px",
    textAnchor: "middle"
  }, "\u5ECA&#xa;\u4E0B")))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 305,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 270,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 210,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 170,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 110,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 10,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 70,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 100,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 180,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 260,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 300,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 330,
    width: 20,
    height: 10,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  }))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap6);
export default __webpack_public_path__ + "static/media/map_6.a3fb038cb107cde24f610f4285d61589.svg";
export { ForwardRef as ReactComponent };